/* eslint-disable */
const ENVIRONMENTS = [
    // DEV (LOCAL)
    {
        front: 'localhost'
        // api: 'http://bp-2017.local:3000'
    }
]

const currentURL = window.location.href.toLowerCase()
const testFont = env => currentURL.search(env.front.toLowerCase()) > -1

const env = ENVIRONMENTS.find(testFont) || ENVIRONMENTS[ENVIRONMENTS.length - 1]

export default {
    api: {
        base_url: ''
    },

    json: {
        taxonomies: {
            url: '/static/json/taxonomies.json'
        },
        global: {
            url: '/static/json/global.json'
        }
    },

    pages: {
        default: {
            path: '/',
            redirect: '/home'
        },
        homeSlide: {
            path: '/home/:slug',
            name: 'page-home-slide',
            meta: {
                component: 'page-home',
                seo: 'home_:slug'
            }
        },
        home: {
            path: '/home',
            name: 'page-home',
            meta: {
                component: 'page-home',
                seo: 'home_:slug'
            }
        },
        team: {
            path: '/team',
            name: 'page-team',
            meta: {
                component: 'page-team',
                seo: 'team'
            }
        },
        token: {
            path: '/token',
            name: 'page-token',
            meta: {
                component: 'page-token',
                seo: 'token'
            }
        },
        presale: {
            path: '/presale',
            name: 'page-presale',
            meta: {
                component: 'page-presale',
                seo: 'presale'
            }
        },
        platform: {
            path: '/platform',
            name: 'page-platform',
            meta: {
                component: 'page-platform',
                seo: 'platform'
            }
        },
        sample: {
            path: '/sample',
            name: 'page-sample',
            meta: {
                component: 'page-sample'
            }
        },
        404: {
            path: '*',
            name: 'page-404',
            meta: {
                component: 'page-404',
                seo: '404'
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/config.js